import { queryCmsContent } from '$server/modules/cms';
import MainLayout from '$layout/MainLayout';
import CookiePolicy from '$components/CookiePolicy';
import { QUERY_GET_FOOTER_CMS_CONTENT } from '$components/layout/Footer/gql/queries/getFooterCmsContent';
import { QUERY_READ_FOOTER_DATA } from '$components/layout/Footer/gql/queries/readFooterData';
import { getNavbarQuery } from '$commons/gql';
import { getVrmLookupQuery } from '$quantum/molecules/VrmLookup/gql';
import { GET_COOKIE_POLICY_CMS } from '$components/CookiePolicy/gql/queries/getCookiePolicyCMS';
import { getPromotionBannerQuery } from '$quantum/molecules/PromotionBanner/gql';
import { GET_HOMEPAGE_OPEN_GRAPH_CONTENT, GET_DOMAIN_VERIFICATION_CONTENT } from '$layout/MainLayout/gql';
import { useAppContext } from '$util/AppContext';
import { getShortTextByKey } from '$cms/getDataByKey';
import { getMetaTitle } from '$components/pages/gql';
import { isPreviewActive } from '$server/modules/cms/util';
import { getLocaleFromHostname } from '$util/domains';
import { WithResponsiveGlobalStyles } from '$util/theme/withResponsive';
import { CACHE_CONTROL_CACHE_ENABLED, CACHE_CONTROL_NO_CACHE } from '../internals/next/config/headers';

const PAGE_NAME = 'cookie-policy';

function CookiePolicyPage() {
  const AppContext = useAppContext();
  const {
    cmsContent: { dictionary },
  } = AppContext;
  const getShortText = getShortTextByKey.bind(dictionary);
  const pageTitle = getShortText('metaTitle.cookiePolicy', 'Cookie policy | Fixter');

  return (
    <MainLayout seo={{ noindex: false, nofollow: false, title: pageTitle }}>
      <WithResponsiveGlobalStyles />
      <CookiePolicy />
    </MainLayout>
  );
}

export const getServerSideProps = async function ({ req, res, query: urlQuery, preview: isPreviewMode }) {
  const locale = getLocaleFromHostname(req.headers.host || '');

  const preview = isPreviewActive(urlQuery, isPreviewMode);
  const cmsContent = await queryCmsContent(PAGE_NAME, {
    cmsQuery: [
      GET_HOMEPAGE_OPEN_GRAPH_CONTENT,
      GET_DOMAIN_VERIFICATION_CONTENT,
      getNavbarQuery,
      getVrmLookupQuery,
      QUERY_GET_FOOTER_CMS_CONTENT,
      GET_COOKIE_POLICY_CMS,
      getPromotionBannerQuery,
      getMetaTitle,
    ],
    resQuery: [QUERY_READ_FOOTER_DATA],
    context: {
      variables: { locale },
      preview,
    },
  });

  if (preview) res.setHeader('Cache-Control', CACHE_CONTROL_NO_CACHE);
  else res.setHeader('Cache-Control', CACHE_CONTROL_CACHE_ENABLED);

  return {
    props: { initChat: false, cmsContent },
  };
};

export default CookiePolicyPage;
